import { render, staticRenderFns } from "./TravelServicePKPIntercityView.vue?vue&type=template&id=338c403f&scoped=true&"
import script from "./TravelServicePKPIntercityView.vue?vue&type=script&lang=js&"
export * from "./TravelServicePKPIntercityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c403f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('338c403f')) {
      api.createRecord('338c403f', component.options)
    } else {
      api.reload('338c403f', component.options)
    }
    module.hot.accept("./TravelServicePKPIntercityView.vue?vue&type=template&id=338c403f&scoped=true&", function () {
      api.rerender('338c403f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/travel-service/TravelServicePKPIntercityView.vue"
export default component.exports